<template>
    <div class="core-checkbox">
        <Checkbox
            :modelValue="modelValue"
            @update:modelValue="$emit('update:modelValue', $event)"
            :inputId="name"
            :name="name"
            :binary="true"
            :disabled="disabled"
            size="large"
        />
        <label
            v-if="label"
            :for="name"
            class="text-200"
            >{{ $t(label) }}</label
        >
    </div>
</template>

<script>
import Checkbox from 'primevue/checkbox'

export default {
    name: 'CoreCheckbox',

    components: { Checkbox },

    props: {
        modelValue: {
            type: Boolean,
            default: false,
        },

        name: {
            type: String,
            required: true,
        },

        label: {
            type: String,
            default: '',
        },

        disabled: {
            type: Boolean,
            default: false,
        },
    },
}
</script>

<style>
.core-checkbox {
    display: flex;
    align-items: center;
    width: fit-content;
    gap: 4px;
}

.core-checkbox:has(input:disabled) .p-checkbox-box {
    background-color: var(--color-disabled-bg);
}
</style>
